/** `host-visibility` / the `hostVisibility` prop: 'shown' or 'hidden'; anything else means "the page decides". */
export function parseHostVisibility(value) {
    return value === 'shown' || value === 'hidden' ? value : undefined;
}
/** The page's own visibility; true where the API is missing or throws (never stop work on a guess). */
export function documentIsVisible(doc = typeof document === 'undefined' ? undefined : document) {
    try {
        return doc === undefined || doc.visibilityState !== 'hidden';
    }
    catch {
        return true;
    }
}
/** Open, and on screen by the host's word when it gave one, else by the page's. */
export function surfaceOnScreen(open, hostVisibility, pageVisible) {
    if (!open)
        return false;
    return hostVisibility ? hostVisibility === 'shown' : pageVisible;
}
//# sourceMappingURL=visibility.js.map